import { render } from "./LpnewThankyouView.vue?vue&type=template&id=08c24147"
import script from "./LpnewThankyouView.vue?vue&type=script&lang=js"
export * from "./LpnewThankyouView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__